export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem('user'))

  if (user && user.token) {
    return {
      Authorization: 'Bearer ' + user.token,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
      // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
      // 'Access-Control-Allow-Headers': 'Content-Type',
    }
  } else {
    return {}
  }
}

export function authHeaderJson() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem('user'))

  if (user && user.token) {
    return {
      // "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${user.token}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    }
  } else {
    return {}
  }
}
